import type { Explanation, Question } from '../types';

export type UiLang = 'pt' | 'en' | 'es';

export function optionsToPlain(options: Question['options']): Record<string, string> {
    const o = options as unknown as Record<string, string> | Map<string, string>;
    if (o && typeof (o as Map<string, string>).entries === 'function') {
        return Object.fromEntries((o as Map<string, string>).entries()) as Record<string, string>;
    }
    return { ...(o || {}) } as Record<string, string>;
}

export function explanationToPlain(e: Explanation | undefined): { general: string; options: Record<string, string> } | undefined {
    if (!e) return undefined;
    const opts = e.options as unknown as Record<string, string> | Map<string, string>;
    let plainOpts: Record<string, string> = {};
    if (opts && typeof (opts as Map<string, string>).entries === 'function') {
        plainOpts = Object.fromEntries((opts as Map<string, string>).entries()) as Record<string, string>;
    } else {
        plainOpts = { ...(opts || {}) } as Record<string, string>;
    }
    return { general: e.general || '', options: plainOpts };
}

/** Assinatura do conteúdo fonte (PT) para cache; não inclui idioma de destino. */
export function displaySourceSig(q: Question): string {
    try {
        const o = optionsToPlain(q.options);
        const sortedOpts = Object.fromEntries(Object.keys(o).sort().map((k) => [k, o[k]]));
        const e = explanationToPlain(q.explanation);
        const explStable = e
            ? { general: e.general, options: Object.fromEntries(Object.entries(e.options).sort(([a], [b]) => a.localeCompare(b))) }
            : undefined;
        return JSON.stringify({ t: q.text, o: sortedOpts, e: explStable });
    } catch {
        return String(q.id);
    }
}
